import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CountBadgeType } from 'src/app/core/state/notifications/notifications.model';

export const COUNT_BADGE_CAP = 99;

/**
 * SAN-1431 (T4.4, BRD §7.2, NFR-08) — the one badge used by every
 * notification-centre counter: red = needs your action, orange = new since
 * your last visit, outlined = live count. Hidden at 0, capped at "99+",
 * always carries an aria-label ("4 pending connection requests").
 * SAN-1461 — role="img", not "status": a status role made every badge a live
 * region that re-announced a bare "4" on each counter poll.
 */
@Component({
  selector: 'app-count-badge',
  templateUrl: './count-badge.component.html',
  styleUrls: ['./count-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountBadgeComponent {
  @Input() count: number = 0;
  @Input() type: CountBadgeType = 'action';
  // What is being counted, e.g. "pending connection requests".
  @Input() label: string = '';

  get visible(): boolean {
    return Number(this.count) > 0;
  }

  get display(): string {
    return Number(this.count) > COUNT_BADGE_CAP ? `${COUNT_BADGE_CAP}+` : `${Number(this.count)}`;
  }

  get ariaLabel(): string {
    return `${Number(this.count)} ${this.label}`.trim();
  }
}
